import React from "react";
import { Box } from "@material-ui/core";
import { CustomDialog } from "../../../../../Components";
import LinkToOfferDialogBody from "../../../ClientTrackingView/ClientsTrackingUtilities/Components/LinkToOfferDialogBody";
import ContactAndLeadInfo from "../../../../../Components/CreateLeadDialog/components/ContactAndLeadInfo";

import useStyles from "./styles";

function LinkOfferDialog({ contactDetails, onClose = () => {}, open }) {
  const styles = useStyles();
  let parsedContactDetails =
    {
      ...contactDetails,
      contact: {
        ...contactDetails,
      },
    } || {};
  if (contactDetails?.contactJson) {
    parsedContactDetails = JSON.parse(contactDetails?.contactJson || "{}");
  }
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={"Link Offer"}
      paperClassName={styles.dialogWrapper}
      content={
        <Box>
          <ContactAndLeadInfo contact={parsedContactDetails} />
          <LinkToOfferDialogBody
            onClose={onClose}
            isAfterSales={true}
            fullName={contactDetails?.contactName || contactDetails?.name}
            email={
              parsedContactDetails?.contact?.email_address?.email ||
              parsedContactDetails?.contact?.general_email?.email ||
              ""
            }
            phoneNumber={
              parsedContactDetails?.contact?.mobile?.phone ||
              parsedContactDetails?.contact?.landline_number?.phone ||
              ""
            }
            contactType={parsedContactDetails?.contact_type_id || ""}
          />
        </Box>
      }
      showActions={false}
    />
  );
}

export default LinkOfferDialog;
